import validator from 'validator'

const passwordNonRestrictiveConfig = {
  minLength: 0,
  minLowercase: 0,
  minUppercase: 0,
  minNumbers: 0,
  minSymbols: 0,
}

export const strongPasswordConfig = {
  minLength: 8,
  minLowercase: 1,
  minUppercase: 1,
  minNumbers: 1,
  minSymbols: 1,
}

const isValid = (value, prop) =>
  validator.isStrongPassword(value, {
    ...passwordNonRestrictiveConfig,
    [prop]: strongPasswordConfig[prop],
  })

export const passwordRequirements = [
  {
    id: '1',
    title: '8 Characters',
    validator(value) {
      this.checked = isValid(value?.trim(), 'minLength')
    },
  },
  {
    id: '2',
    title: 'One number',
    validator(value) {
      this.checked = isValid(value, 'minNumbers')
    },
  },
  {
    id: '3',
    title: 'One lower case character',
    validator(value) {
      this.checked = isValid(value, 'minLowercase')
    },
  },
  {
    id: '4',
    title: 'One special character',
    validator(value) {
      this.checked = isValid(value, 'minSymbols')
    },
  },
  {
    id: '5',
    title: 'One upper case character',
    validator(value) {
      this.checked = isValid(value, 'minUppercase')
    },
  },
]
